// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/transaction-counts-report/components/transaction-counts-header/transaction-counts-header.less
// module id = 3946
// module chunks = 0